import { call, put, select, takeLatest } from 'redux-saga/effects'

import { selectAuthToken } from '@store/auth'
import {
  IXMetricsResponse,
  selectXMetricsLink,
  XMetricsActionTypes,
} from '@store/postCampaignReport'
import {
  fetchXMetrics,
  fetchXMetricsError,
  fetchXMetricsSuccess,
} from '@store/postCampaignReport/xMetrics/actions'
import { networkRequest } from '@utils'
import { WatcherFunction } from '..'

export function* handleFetchXMetrics(action: ReturnType<typeof fetchXMetrics>) {
  const campaignId = action.payload

  try {
    const link = yield select(selectXMetricsLink, campaignId)
    const authToken: string = yield select(selectAuthToken)

    const metrics: IXMetricsResponse = yield call(
      networkRequest,
      link.method,
      link.href,
      undefined,
      authToken,
    )

    yield put(fetchXMetricsSuccess(metrics, campaignId))
  } catch (error) {
    yield put(fetchXMetricsError(error))
  }
}

function* watchFetchXMetrics() {
  yield takeLatest(XMetricsActionTypes.FETCH_REQUEST, handleFetchXMetrics)
}

export const xMetricsSagas: ReadonlyArray<WatcherFunction> = [watchFetchXMetrics]
